import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "card-header-row"
};
const _hoisted_2 = {
  class: "header-left"
};
const _hoisted_3 = {
  class: "header-title-row"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "card-status"
};
const _hoisted_6 = ["aria-label", "aria-expanded"];
const _hoisted_7 = {
  class: "geo-report-content"
};
const _hoisted_8 = {
  key: 0,
  class: "report-frame-wrap"
};
const _hoisted_9 = ["srcdoc"];
const _hoisted_10 = {
  key: 1,
  class: "text-sm text-[#86909C]"
};
const _hoisted_11 = {
  key: 0,
  class: "report-actions flex justify-end m-4 gap-2"
};
import { ref, onMounted, onUnmounted, computed, watch, nextTick, inject } from 'vue';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { setFoldFunc, removeFoldFunc } from '@views/main/states/fold.state';
import { ElMessage } from 'element-plus';
import html2canvas from 'html2canvas';
import initIncrementalUpdate from '../report-items/mixins/incrementalUpdate.mixin';
import sparklesIcon from './geo-analysis-sparkles.png';
const title = '多格式报告导出';
export default /*@__PURE__*/_defineComponent({
  __name: 'GeoReport',
  props: {
    item: {},
    content: {}
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const mainStore = useMainStore();
    const {
      incrementalMessageList,
      conversationList
    } = storeToRefs(mainStore);
    const iframeRef = ref();
    const openSidePreview = inject('openSidePreview');
    const info = ref({});
    const htmlContent = ref('');
    const iframeHeight = ref('0px');
    const isFold = ref(false);
    const titleSuffix = computed(() => {
      if (info.value.executeStatus === 3) return '(已完成)';
      if (info.value.executeStatus === 2) return '(失败)';
      return '';
    });
    const adjustIframeHeight = () => {
      const iframe = iframeRef.value;
      if (!iframe) return;
      try {
        const body = iframe.contentDocument?.body;
        const html = iframe.contentDocument?.documentElement;
        if (body && html) {
          const height = Math.max(body.scrollHeight, html.scrollHeight);
          iframeHeight.value = `${height}px`;
        }
      } catch {
        iframeHeight.value = '800px';
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      if (props.item.id === message.id) {
        const {
          incrementalData
        } = message;
        if (incrementalData.html) {
          htmlContent.value = incrementalData.html;
        }
        if (incrementalData.error) {
          info.value.executeStatus = 2;
        }
      }
    });
    const handleFullScreen = () => {
      if (!htmlContent.value) return;
      const taskName = info.value.taskName || '报告预览';
      // 移除 URL 前缀作为标题
      const title = taskName.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
      openSidePreview({
        title,
        type: 'html',
        html: htmlContent.value
      });
    };
    const isDownloading = ref(false);
    const handleDownload = async () => {
      if (isDownloading.value) return;
      const target = iframeRef.value?.contentDocument?.body;
      if (!target) {
        ElMessage.warning('报告生成中，请稍后再试');
        return;
      }
      try {
        isDownloading.value = true;
        await nextTick();
        // 复用预览 iframe：报告内联 CSS 已隔离在 iframe 内，不会污染宿主页面
        const width = target.scrollWidth;
        const height = target.scrollHeight;
        const canvas = await html2canvas(target, {
          useCORS: true,
          scale: 1.5,
          backgroundColor: '#121416',
          width,
          height,
          windowWidth: width,
          windowHeight: height
        });
        const {
          default: JsPDF
        } = await import('jspdf');
        const pageW = 794;
        const pageH = 1123;
        const imgW = pageW;
        const imgH = canvas.height * imgW / canvas.width;
        const pdf = new JsPDF({
          orientation: 'portrait',
          unit: 'px',
          format: [pageW, pageH]
        });
        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        let rendered = 0;
        let pageIdx = 0;
        while (rendered < imgH) {
          if (pageIdx > 0) pdf.addPage();
          // 页面背景填 #121416，覆盖末页等非内容区域，避免白底
          pdf.setFillColor(18, 20, 22);
          pdf.rect(0, 0, pageW, pageH, 'F');
          pdf.addImage(imgData, 'JPEG', 0, -rendered, imgW, imgH);
          rendered += pageH;
          pageIdx += 1;
        }
        // 网址在 GeoStart(601) 消息上，不在本报告消息上；从会话列表取
        const startMsg = conversationList.value.find(m => m.messageType === 601);
        const website = startMsg?.content?.websiteInfo || startMsg?.content?.url || info.value.websiteInfo || info.value.url || '';
        const url = website.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
        pdf.save(`${url}分析报告.pdf`);
      } catch (error) {
        console.log(error);
      } finally {
        isDownloading.value = false;
      }
    };
    const initFromContent = () => {
      const mc = info.value.messageContent;
      if (mc?.['60501']?.html) {
        htmlContent.value = mc['60501'].html;
      }
    };
    const toggleFold = val => {
      isFold.value = typeof val === 'boolean' ? val : !isFold.value;
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
      if (props.item.id) removeFoldFunc(props.item.id);
    });
    watch(() => props.content, val => {
      if (!val) return;
      info.value = val;
      initFromContent();
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
        setFoldFunc(props.item.id, toggleFold);
      }
      try {
        info.value = props.content || {};
        initFromContent();
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
      } catch (error) {
        info.value = {};
        console.log(error);
      }
    });
    __expose({
      isFold,
      setIsFold: val => {
        isFold.value = val;
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_down = _resolveComponent("i-home-down");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("article", {
        class: _normalizeClass(["process-card geo-card", {
          'is-collapsed': isFold.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "card-sparkles-img",
        src: _unref(sparklesIcon),
        alt: ""
      }, null, 8, _hoisted_4), _createElementVNode("span", {
        class: "card-title truncat"
      }, _toDisplayString(title)), _createElementVNode("span", _hoisted_5, _toDisplayString(titleSuffix.value), 1)])]), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["collapse-button", {
          'is-fold': isFold.value
        }]),
        "aria-label": isFold.value ? '展开' : '收起',
        "aria-expanded": !isFold.value,
        onClick: _cache[0] || (_cache[0] = $event => toggleFold())
      }, [_createVNode(_component_el_icon, {
        class: "collapse-icon",
        color: "#4E5969"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_home_down)]),
        _: 1
      })], 10, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [htmlContent.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("iframe", {
        ref_key: "iframeRef",
        ref: iframeRef,
        srcdoc: htmlContent.value,
        title: "多格式报告导出预览",
        class: "report-iframe",
        style: _normalizeStyle({
          height: iframeHeight.value
        }),
        scrolling: "no",
        onLoad: adjustIframeHeight
      }, null, 44, _hoisted_9)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, "等待报告生成..."))]), htmlContent.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_button, {
        onClick: handleFullScreen
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("全屏查看", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        loading: isDownloading.value,
        onClick: handleDownload
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 下载报告 ", -1)]))]),
        _: 1
      }, 8, ["loading"])])) : _createCommentVNode("", true)], 2);
    };
  }
});